<template>
<div class="c-step step-8">
  <div>
    <stepsCounter></stepsCounter>
    <div class="c-step-ask">
      Czy w pobliżu tego miejsca jest stacja benzynowa?
    </div>
  </div>
  <div class="c-step-answers">
    <button v-on:click="answer('Tak')">Tak</button>
    <button v-on:click="answer('Nie')">Nie</button>
  </div>
</div>
</template>

<script>
import {
  mapActions
} from 'vuex'

import stepsCounter from './../stepsCounter'

export default {
  name: 'step8',
  components: {
    'stepsCounter': stepsCounter
  },
  methods: {
    answer(answer, substep = null) {
      this.$store.dispatch('answer', {
        step: '8',
        answer: answer,
        substep: substep
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
